export default __webpack_public_path__ + "static/logo-41ad24022964dee00339e92efe6003b6.svg";